import React from 'react';
import { CheckIcon } from 'lucide-react';
import { SectionLabel } from './SectionLabel';
import { CountdownClock } from './CountdownClock';
import { CtaButton } from './CtaButton';
import { PRICE, TOTAL_VALUE, SAVINGS } from '../data/offer';
const ASSURANCES = ['One-time payment · No subscription', 'Instant digital delivery of every guide', '30-day “Happy Tail” guarantee'];
export function FinalCountdown() {
  return <section className="w-full border-y border-line bg-white" aria-labelledby="final-countdown-heading" data-id="element-96" data-mp="11q55gudsesrb">
      <div className="mx-auto max-w-3xl px-4 py-14 text-center sm:px-5 sm:py-24" data-id="element-97" data-mp="15sjkf3ec58db">
        <SectionLabel align="center" data-id="element-98" data-mp="ryisotlswlmg">Final countdown</SectionLabel>

        <h2 id="final-countdown-heading" className="mt-5 font-display text-[1.75rem] font-semibold leading-tight text-ink sm:mt-6 sm:text-[2.5rem]" data-id="element-99" data-mp="wxbwfubacy9f">
          Complete bundle, flash-sale price
        </h2>

        <div className="mt-8 sm:mt-10" data-id="element-100" data-mp="1pfqzl3fayhsg">
          <CountdownClock size="lg" align="center" data-id="element-101" data-mp="2rnx6wwxt3ypq" />
        </div>

        <p className="mt-10 text-[10px] font-bold uppercase tracking-[0.16em] text-terracotta sm:mt-12 sm:text-[11px] sm:tracking-[0.18em]" data-id="element-102" data-mp="2rm40nir3vgi9">
          30-Day system + 5 bonuses
        </p>

        <div className="mt-4 flex items-end justify-center gap-3 sm:gap-4" data-id="element-103" data-mp="31fb1qretcacj">
          <span className="font-display text-5xl font-semibold leading-none tracking-[-0.03em] text-ink sm:text-7xl" data-id="element-104" data-mp="2wmhx03jch20g">
            ${PRICE}
          </span>
          <span className="pb-2 font-display text-2xl text-muted line-through" data-id="element-105" data-mp="36d3289tix4sc">
            ${TOTAL_VALUE}
          </span>
        </div>

        <p className="mt-4 text-sm text-muted" data-id="element-106" data-mp="3kbt2tzfjxmlg">You save ${SAVINGS} today</p>

        <CtaButton size="lg" className="mt-9" data-id="element-107" data-mp="3fd9gvz0ykat3">
          Yes! I want it now
        </CtaButton>

        <ul className="mx-auto mt-8 flex max-w-md flex-col items-start gap-3 border-t border-line pt-7 text-left sm:items-center" data-id="element-108" data-mp="1pyba7y0ahzjk">
          {ASSURANCES.map(item => <li key={item} className="flex items-start gap-3" data-id="element-109" data-mp="1l24gd3l64ehz">
              <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-moss" aria-hidden="true" data-id="element-110" data-mp="3l3kg3g9xr9e1" />
              <span className="text-sm text-ink/85" data-id="element-111" data-mp="3v06ze0mm5sdy">{item}</span>
            </li>)}
        </ul>
      </div>
    </section>;
}